import { PlanType } from "./plan-type";

export enum PlanId {
    Business = "prod_PlGtC5ecbeTmzF",
    Core = "prod_RjMhBvYd5f9OIv",
    Pro = "prod_RjMhTCoR1UGSfb",
}

export const PlanIdPlanType: { [key: string | PlanId]: PlanType } = {
    [PlanId.Core]: PlanType.Core,
    [PlanId.Pro]: PlanType.Pro,
}